import { User } from '../user/types';
// STATE

export interface AuthState {
    user?: User;
    pending: boolean;
}

// ACTION TYPES

// eslint-disable-next-line import/prefer-default-export
export enum AuthType {
    SET_AUTH = 'auth/SET_AUTH',
    LOGOUT = 'auth/LOGOUT',
}

// ACTION CREATORS

export interface SetAuthAction {
    type: typeof AuthType.SET_AUTH;
    user?: User;
    pending: boolean;
}

export interface LogoutAction {
    type: typeof AuthType.LOGOUT;
}

export type AuthActionTypes = SetAuthAction | LogoutAction;
